import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { Input, Button, Image } from "antd";
import Interview from "../assets/svgs/interview.svg";
import Progress from "./Progress";
import { trackEvent } from "../helpers/analytics";

const Allergies = (props) => {
  const { allergies, hasAllergies } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [allergy, setAllergy] = useState("");
  const [showInputField, setShowInputField] = useState(hasAllergies === true);

  useEffect(() => {
    document.title = "Allergies Question - UTIRX";
    trackEvent("step_view", "Allergies Question", 2);

  }, []);

  // Update showInputField when hasAllergies changes (e.g., when navigating back)
  useEffect(() => {
    setShowInputField(hasAllergies === true);
  }, [hasAllergies]);

  const handleInputChange = (e) => {
    if (e.target.value.at(-1) !== ",") {
      setAllergy(e.target.value);
    } else if (allergy.length > 0) {
      addAllergy();
    }
  };

  const addAllergy = () => {
    if (allergy.trim() !== "") {
      let mAllergies = allergies;
      const found = mAllergies.find(
        (element) => element.toLowerCase() === allergy.toLowerCase()
      );
      if (!found) {
        mAllergies.push(allergy);
        dispatch({ type: "SET_ALLERGIES", allergies: [...mAllergies] });
      }
      setAllergy("");
    }
  };

  const keyDown = (e) => {
    if (e.keyCode === 13 && allergy !== "") {
      addAllergy();
    }
  };

  const incrementStep = () => {
    if (allergy.length > 0) {
      addAllergy();
    }
    props.incrementStep(allergies);
  };

  const handleYesClick = () => {
    dispatch({ type: "SET_HAS_ALLERGIES", hasAllergies: true });
    setShowInputField(true);
  };

  const handleNoClick = () => {
    // Clear any existing allergies and move to next step
    dispatch({ type: "SET_HAS_ALLERGIES", hasAllergies: false });
    dispatch({ type: "SET_ALLERGIES", allergies: [] });
    setAllergy("");
    setShowInputField(false);
    props.incrementStep([]);
  };

  const deleteAllergy = (item) => {
    dispatch({
      type: "SET_ALLERGIES",
      allergies: allergies.filter((i) => i !== item),
    });
  };

  return (
    <div className="flex column question-container">
      <div className="responsive">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {props.index !== 0 && (
            <>
              <p
                onClick={() => {
                  props.decrementStep();
                }}
                className="link-button"
              >
                Previous
              </p>
              <p onClick={props.resetQuestion} className="link-button">
                Restart
              </p>
            </>
          )}
        </div>
      </div>
      <div style={{ marginTop: props.index === 0 ? "30px" : "0px" }}>
        {" "}
        <Progress current={props.index} total={props.total} />
      </div>
      {/* <div className="back-container">
        <p className="link-button" onClick={() => props.decrementStep()}>
          Go Back
        </p>
      </div> */}
      <div
        className="flex responsive"
        style={{ justifyContent: "space-between", alignItems: "flex-start" }}
      >
        <div className="interview">
          <Image src={Interview} preview={false} width={"90%"} />
        </div>

        <div
          className="flex column allergies question"
          style={{ marginTop: "72px" }}
        >
          <span style={{ color: "#0064A9" }}>
            Question {props.index + 1} of {props.total}
          </span>
          <p>Do you have any allergies?</p>
          
          {hasAllergies === null || !showInputField ? (
            // Show Yes/No buttons initially or when coming back
            <>
              <p className="helper-message">
                Please select Yes if you have any allergies, or No if you don't have any allergies.
              </p>
              <br />
              <div style={{ display: "flex", gap: "16px", marginTop: "20px" }}>
                <Button 
                  type={hasAllergies === true ? "primary" : "default"}
                  onClick={handleYesClick}
                  style={{
                    backgroundColor: hasAllergies === true ? "#0064A9" : "transparent",
                    borderColor: "#0064A9",
                    color: hasAllergies === true ? "white" : "#0064A9",
                    minWidth: "100px"
                  }}
                >
                  Yes
                </Button>
                <Button 
                  type={hasAllergies === false ? "primary" : "default"}
                  onClick={handleNoClick}
                  style={{
                    backgroundColor: hasAllergies === false ? "#0064A9" : "transparent",
                    borderColor: "#0064A9",
                    color: hasAllergies === false ? "white" : "#0064A9",
                    minWidth: "100px"
                  }}
                >
                  No
                </Button>
              </div>
              {hasAllergies === true && (
                <div style={{ marginTop: "20px" }}>
                  <Button
                    type="link"
                    onClick={() => setShowInputField(true)}
                    style={{ color: "#0064A9", padding: 0 }}
                  >
                    Continue to add allergies →
                  </Button>
                </div>
              )}
            </>
          ) : (
            // Show input field and allergy management after Yes is clicked
            <>
              <p className="helper-message">
                Please list your allergies in the box below and click the 'Add' button.
              </p>
              
              <br />
              <Input.Group compact style={{ width: "100%", display: "flex" }}>
                <Input
                  onChange={handleInputChange}
                  onKeyDown={keyDown}
                  value={allergy}
                  style={{ flex: 1 }}
                  placeholder="Enter an allergy..."
                />
                <Button 
                  type="primary"
                  onClick={addAllergy}
                  style={{
                    backgroundColor: "#0064A9",
                    borderColor: "#0064A9"
                  }}
                >
                  Add
                </Button>
              </Input.Group>
              <div className="chips">
                {allergies.map((item) => {
                  return (
                    <div className="chip" key={`allergy-${item}`}>
                      <span className="allergy">{item.slice(0, 30)}{item.length > 30 ? '...' : ''}</span>
                      <button
                        type="button"
                        className="close-button"
                        onClick={() => deleteAllergy(item)}
                        aria-label={`Remove ${item}`}
                      >
                        &times;
                      </button>
                    </div>
                  );
                })}
              </div>
              <div style={{ display: "flex", gap: "16px", marginTop: "20px" }}>
                <Button
                  onClick={() => {
                    dispatch({ type: "SET_HAS_ALLERGIES", hasAllergies: null });
                    setShowInputField(false);
                  }}
                  style={{
                    borderColor: "#0064A9",
                    color: "#0064A9"
                  }}
                >
                  Back to Yes/No
                </Button>
                <Button
                  onClick={() => incrementStep()}
                  type="primary"
                  style={{ backgroundColor: "#0064A9" }}
                >
                  Continue
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

Allergies.propTypes = {
  incrementStep: PropTypes.func.isRequired,
  decrementStep: PropTypes.func,
  resetQuestion: PropTypes.func,
  index: PropTypes.number,
  total: PropTypes.number,
};

export default Allergies;